import { Box, Card, Typography, styled } from "@mui/material";

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const SectionSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const PeriodDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  minHeight: "3.75rem",
}));

export const TestTypeCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$selected" && prop !== "$disabled",
})<{ $selected?: boolean; $disabled?: boolean }>(
  ({ theme, $selected, $disabled }) => ({
    border: `1px solid ${
      $selected ? theme.palette.primary.main : theme.palette.divider
    }`,
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(2),
    backgroundColor: $selected
      ? theme.palette.primary.light + "18"
      : theme.palette.background.paper,
    opacity: $disabled ? 0.6 : 1,
    flex: 1,
  }),
);

export const SummaryWrap = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: theme.spacing(2),
}));

export const MetricCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "$selected",
})<{ $selected?: boolean }>(({ theme, $selected }) => ({
  border: `1px solid ${
    $selected ? theme.palette.primary.main : theme.palette.divider
  }`,
  boxShadow: "none",
  height: "100%",
  backgroundColor: $selected ? theme.palette.primary.light + "14" : "inherit",
}));

export const MetricIconBubble = styled(Box)<{ $size?: number }>(
  ({ theme, $size }) => ({
    width: $size || 30,
    height: $size || 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.palette.primary.light + "2e",
    color: theme.palette.primary.main,
    "& svg": {
      fontSize: $size ? `${$size / 1.5}px` : undefined,
    },
  }),
);
